<footer class="footer">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-between">

            <!-- Copyright -->
            <div class="col-auto text-left">
                <span class="copyright-text">
                    {{year}} © <strong>Agile Legal</strong>
                </span>
            </div>

            <!-- Links -->
            <div class="col-auto">
                <ul class="footer-links list-inline mb-0">
                    <li class="list-inline-item mx-3">
                        <a href="https://agilelegal.atlassian.net/jira/software/form/6339ecc4-7672-4c47-af97-895683777660"
                           target="_blank" rel="noopener noreferrer">
                            <i class="mdi mdi-lifebuoy mr-1"></i> Request Assistance
                        </a>
                    </li>
                    <li class="list-inline-item mx-3">
                        <a href="https://agilelegal.atlassian.net/jira/software/projects/ARLO/form/68?atlOrigin=eyJpIjoiZTY4YWVkYjRmNGY0NGRlMTg4ZWQ0OTNmZWQ1ODczMjQiLCJwIjoiaiJ9"
                           target="_blank" rel="noopener noreferrer">
                            <i class="mdi mdi-lightbulb-outline mr-1"></i> Suggest a Feature
                        </a>
                    </li>
                    <li class="list-inline-item mx-3">
                        <a href="https://agilelegal.atlassian.net/jira/software/form/8afe89cb-b106-48db-bed2-ba186d7b13f3"
                           target="_blank" rel="noopener noreferrer">
                            <i class="mdi mdi-bug-outline mr-1"></i> Report an Issue
                        </a>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</footer>
